__turbopack_context__.v({
  "h1": "MPwxPG_h1",
  "h1Opt": "MPwxPG_h1Opt",
  "h2": "MPwxPG_h2",
  "h2Large": "MPwxPG_h2Large",
  "h2Opt": "MPwxPG_h2Opt",
  "h2Small": "MPwxPG_h2Small",
  "h3": "MPwxPG_h3",
  "larger": "MPwxPG_larger",
  "leftSideTextWrapper": "MPwxPG_leftSideTextWrapper",
  "p": "MPwxPG_p",
  "pBody": "MPwxPG_pBody",
  "pLarge": "MPwxPG_pLarge",
  "pLargeGradient": "MPwxPG_pLargeGradient",
  "pOpt": "MPwxPG_pOpt",
});
